import React from 'react';

import { FilterBottomSheet, useT } from '@repo/common';

import { ReactComponent as BookmarkOutlineIcon } from '@repo/common/assets/icons/20px/icon_20px_bookmark_outline.svg';
import { ReactComponent as BookmarkFilledIcon } from '@repo/common/assets/icons/20px/icon_20px_bookmark_filled.svg';
import { ReactComponent as HiddenIcon } from '@repo/common/assets/icons/20px/icon_20px_hidden.svg';
import { ReactComponent as VisibleIcon } from '@repo/common/assets/icons/20px/icon_20px_visible_outline.svg';
import { ReactComponent as OfficeBuildingIcon } from '@repo/common/assets/icons/20px/icon_20px_office-building_outline.svg';

/**
 * 모바일 상세 페이지 오버플로우(⋮) 메뉴 — 바텀시트.
 * 저장/숨김 상태에 따라 라벨과 아이콘이 바뀐다.
 */
const MobileJobActionsSheet = ({
  isSaved,
  isHidden,
  onToggleSave,
  onToggleHide,
  onViewCompany,
  onClose,
}) => {
  const t = useT();

  const actions = [
    {
      key: 'save',
      icon: isSaved ? <BookmarkFilledIcon /> : <BookmarkOutlineIcon />,
      label: isSaved
        ? t('Remove from saved', '저장 취소')
        : t('Save job', '공고 저장'),
      onClick: onToggleSave,
    },
    {
      key: 'hide',
      icon: isHidden ? <VisibleIcon /> : <HiddenIcon />,
      label: isHidden
        ? t('Show this job again', '이 공고 다시 보기')
        : t('Hide this job', '이 공고 숨기기'),
      onClick: onToggleHide,
    },
    {
      key: 'company',
      icon: <OfficeBuildingIcon />,
      label: t('View company', '회사 정보 보기'),
      onClick: onViewCompany,
    },
  ].filter((action) => Boolean(action.onClick));

  return (
    <FilterBottomSheet fullWidth onClose={onClose}>
      <ul role='menu' className='m-0 flex w-full list-none flex-col p-0'>
        {actions.map((action) => (
          <li key={action.key} role='none'>
            <button
              type='button'
              role='menuitem'
              onClick={() => {
                action.onClick?.();
                onClose?.();
              }}
              className='flex h-[52px] w-full items-center gap-3 rounded-[14px] px-2 text-left text-text-primary transition-colors active:bg-grayscale-gray01'
            >
              <span className='flex size-5 shrink-0 items-center justify-center text-icon-primary'>
                {action.icon}
              </span>
              <span className='typo-b16Strong'>{action.label}</span>
            </button>
          </li>
        ))}
      </ul>
    </FilterBottomSheet>
  );
};

export default MobileJobActionsSheet;
